(() => {
  if (window.rydvltCareMounted) return;
  window.rydvltCareMounted = true;
  const openTarget = () => {
    const id = location.hash.slice(1);
    if (!id.startsWith('care-')) return;
    const detail = document.getElementById(id);
    if (detail?.tagName !== 'DETAILS') return;
    detail.open = true;
    detail.scrollIntoView({block:'start',behavior:'instant'});
  };
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href^="#care-"]');
    if (!link) return;
    const detail = document.getElementById(link.getAttribute('href').slice(1));
    if (detail?.tagName === 'DETAILS') { detail.open = true; detail.querySelector('summary')?.focus({preventScroll:true}); }
  });
  window.addEventListener('hashchange',openTarget);
  openTarget();
})();(() => {
  if(window.rydvltTickerMounted)return;
  window.rydvltTickerMounted=true;
  const toggle=marquee=>{const paused=marquee.dataset.paused!=='true';marquee.dataset.paused=String(paused);marquee.setAttribute('aria-pressed',String(paused));};
  document.addEventListener('click',event=>{const marquee=event.target.closest('[data-marquee]');if(marquee)toggle(marquee);});
  document.addEventListener('keydown',event=>{const marquee=event.target.closest('[data-marquee]');if(marquee&&(event.key==='Enter'||event.key===' ')){event.preventDefault();toggle(marquee);}});
})();
